import React from "react";

/**
 * A custom input for react-datepicker that prevents the mobile keyboard
 * from opening. Uses forwardRef (required by react-datepicker) and blurs
 * immediately on focus so the OS never shows the virtual keyboard.
 */
const NoKeyboardInput = React.forwardRef(({ value, onClick, placeholder, className, style }, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={onClick}
    placeholder={placeholder}
    className={className}
    style={style}
    readOnly
    onFocus={e => e.target.blur()}
    onChange={() => {}}
  />
));

NoKeyboardInput.displayName = "NoKeyboardInput";

export default NoKeyboardInput;
